module.exports = __webpack_public_path__ + "img/PSD.e74b9dd0.png";